import { render, staticRenderFns } from "./cCard.vue?vue&type=template&id=36202f45&scoped=true&"
import script from "./cCard.vue?vue&type=script&lang=js&"
export * from "./cCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36202f45",
  null
  
)

export default component.exports